import { createAction } from 'typesafe-actions';
import { IPumpingStationMotorEfficiency } from '../../../../@types/model/masterData/pumpingStation/motorEfficiency';

export default class MasterDataPumpingStationMotorEfficiencyActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_EFFICIENCY', resolve => (data : Array<IPumpingStationMotorEfficiency>) => resolve(data));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_EFFICIENCY_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}